// Global
import React from 'react';

// Local
import styles from './PromoBanner.module.scss';
import { Themes } from 'lib/themes';
import { BrandAndThemeProvider } from 'components/helpers/ContextProvider/BrandAndThemeContext';

export interface PromoBannerProps {
  icon: React.ReactNode;
  eyebrow: React.ReactNode;
  headline: React.ReactNode;
  subhead: React.ReactNode;
  description: React.ReactNode;
  cta1: React.ReactNode;
  cta2: React.ReactNode;
  image: React.ReactNode;
  theme?: Themes;
}

export const PromoBanner = (props: PromoBannerProps) => {
  /*
   * Rendering
   */

  return (
    <BrandAndThemeProvider theme={props.theme}>
      <div
        id="promo-banner"
        data-component="authorable/shared/content/promo-banner/promo-banner"
        className={styles.promoBanner}
      >
        <div className={styles.content}>
          <div className={styles.imageContainer}>{props.image}</div>
          <div className={styles.copyContainer}>
            <div className={styles.copy}>
              <div className={styles.icon}>{props.icon}</div>
              <div className={styles.eyebrow}>
                <div className={styles.eyebrowText}>{props.eyebrow}</div>
              </div>
              <div className={styles.titleWrapper}>
                <div className={styles.headline}>{props.headline}</div>
                <div className={styles.subhead}>{props.subhead}</div>
              </div>
              <div className={styles.description}>{props.description}</div>
            </div>
            <div className={styles.ctaContainer}>
              {props.cta1}
              {props.cta2}
            </div>
          </div>
        </div>
      </div>
    </BrandAndThemeProvider>
  );
};
